const ONBOARDING_PRODUCTS = {
    ECS: 'ecs',
    LAMBDA: 'lambda',
    KUBERNETES: 'kubernetes',
};

export default ONBOARDING_PRODUCTS;
